import React from 'react';

const TrashCan = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Regular/Light/Delete">
        <g id="Delete">
          <path
            id="Stroke 1"
            d="M14.4938 7.6012C14.4938 7.6012 14.0866 12.6524 13.8503 14.7802C13.7378 15.7964 13.1101 16.3919 12.0818 16.4107C10.1251 16.4459 8.16609 16.4482 6.21009 16.4069C5.22084 16.3867 4.60359 15.7837 4.49334 14.7854C4.25559 12.6389 3.85059 7.6012 3.85059 7.6012"
            stroke="#1A1E27"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 3"
            d="M15.531 5.17981H2.8125"
            stroke="#1A1E27"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 5"
            d="M13.0799 5.1798C12.4912 5.1798 11.9842 4.76355 11.8687 4.1868L11.6864 3.2748C11.5739 2.85405 11.1929 2.56305 10.7587 2.56305H7.58395C7.1497 2.56305 6.7687 2.85405 6.6562 3.2748L6.47395 4.1868C6.35845 4.76355 5.85145 5.1798 5.2627 5.1798"
            stroke="#1A1E27"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default TrashCan;
